import React from 'react';
import './RestaurantSkeleton.css';

interface RestaurantSkeletonProps {
  count?: number;
}

export const RestaurantCardSkeleton: React.FC = () => {
  return (
    <div className="restaurant-card-skeleton">
      <div className="skeleton-restaurant-image"></div>
      <div className="skeleton-restaurant-content">
        <div className="skeleton-restaurant-name"></div>
        <div className="skeleton-restaurant-rating"></div>
        <div className="skeleton-restaurant-cuisines"></div>
        <div className="skeleton-restaurant-location"></div>
      </div>
    </div>
  );
};

export const RestaurantListSkeleton: React.FC<RestaurantSkeletonProps> = ({ count = 6 }) => {
  return (
    <div className="restaurant-list-skeleton">
      {Array.from({ length: count }).map((_, index) => (
        <RestaurantCardSkeleton key={index} />
      ))}
    </div>
  );
};

export default RestaurantListSkeleton;

